import { render, staticRenderFns } from "./WaitingApproval.vue?vue&type=template&id=6dfa0c1b"
import script from "./WaitingApproval.vue?vue&type=script&lang=js"
export * from "./WaitingApproval.vue?vue&type=script&lang=js"
import style0 from "./WaitingApproval.vue?vue&type=style&index=0&id=6dfa0c1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports